import { IState } from "./_interfaces";
import { RESET_GENERAL_REDUCER, RESET_GLOBAL_MESSAGE, SET_GLOBAL_MESSAGE } from "./constants";


const initialState:IState = {
    message: null,
}

const EGeneralReducer = (state:IState = initialState, action:any):IState => {
    const { type, payload } = action;

    switch (type) {
        case SET_GLOBAL_MESSAGE:
            return {
                ...state,
                message: payload,
            }
        
        case RESET_GLOBAL_MESSAGE:
            return {
                ...state,
                message: null,
            }

        case RESET_GENERAL_REDUCER:
            return initialState
    }

    return state;
}

export default EGeneralReducer